import { _js } from '@ifixit/localize';
import { faRedo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const RedoButton = () => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().redo().run()}
         isDisabled={!editor.can().redo()}
         icon={<FontAwesomeIcon icon={faRedo} />}
         title={_js('Redo')}
         shortcut={'y'}
      ></TiptapButton>
   );
};
